import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Tree = _resolveComponent("Tree")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.searchWarningMessageVisible)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          class: "p-m-4",
          severity: "warn",
          closable: false,
          style: _ctx.olapFilterDialogDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.filterDialog.searchWarningMessage')), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    (_ctx.selectedAncestorsWarningVisible)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 1,
          class: "p-m-4",
          severity: "warn",
          closable: false,
          style: _ctx.olapFilterDialogDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.filterDialog.ancestorDescendantWarning')), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    (!_ctx.treeLocked)
      ? (_openBlock(), _createBlock(_component_InputText, {
          key: 2,
          id: "olap-filter-tree-search",
          class: "kn-material-input",
          modelValue: _ctx.searchWord,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchWord = $event)),
          modelModifiers: { trim: true },
          type: "text",
          placeholder: _ctx.$t('common.search'),
          onInput: _ctx.searchTree
        }, null, 8, ["modelValue", "placeholder", "onInput"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Tree, {
      id: "kn-parameter-tree",
      class: { 'olap-filter-tree-locked': _ctx.treeLocked },
      value: _ctx.nodes,
      metaKeySelection: false,
      expandedKeys: _ctx.expandedKeys,
      loading: _ctx.loading,
      onNodeExpand: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadNodes($event)))
    }, {
      default: _withCtx((slotProps) => [
        _withDirectives(_createVNode(_component_Checkbox, {
          class: "p-ml-2",
          modelValue: _ctx.selectedFilters,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedFilters = $event)),
          value: _ctx.filterType === 'slicer' ? slotProps.node.id : slotProps.node.data,
          disabled: _ctx.treeLocked && _ctx.filterType !== 'visible' && !slotProps.node.data.visible,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFiltersSelected()))
        }, null, 8, ["modelValue", "value", "disabled"]), [
          [_directive_tooltip, { value: _ctx.$t('documentExecution.olap.filterDialog.parentDisabledTooltip'), disabled: !_ctx.treeLocked || slotProps.node.data.visible || _ctx.filterType === 'visible' }]
        ]),
        _createVNode("span", null, _toDisplayString(slotProps.node.label), 1)
      ]),
      _: 1
    }, 8, ["class", "value", "expandedKeys", "loading"])
  ]))
}